import * as d3 from "d3";
import { updateSvgID } from "@/plano/elements";

export const QUALITIES = {
    low: "low",
    high: "Pas de low"
};

/**
 * Tri les groupes de teintes en fonction du champs position dans le svg
 * ou par leur coordonnées x,y de haut à gauche (si un des groupes n'a pas n'a pas de champs position)
 * @param {BoardModuleElement} moduleElement
 * @param {Array<ModuleDetails>} moduleDetails
 * @returns {Array<number>}
 */
function sortShades(moduleElement, moduleDetails) {
    const svg = moduleElement.svg;
    if (!svg) {
        console.warn(`The module element ${moduleElement.modelId()} has no svg`);
        return [];
    }
    const cloneSvg = updateSvgID(svg).cloneNode(true);
    try {
        const shades = [];
        document.body.appendChild(cloneSvg);
        const shadesIdPerGroup = moduleElement.shadeByGroup;
        const hasAllPositions = moduleDetails.config.groups.every(group => group.position);
        if (hasAllPositions) {
            const groups = moduleDetails.config.groups.sort((a, b) => a.position - b.position);
            for (const group of groups) {
                const shadeId = shadesIdPerGroup[group.rowId];
                shades.push(shadeId);
            }
            return shades;
        }
        for (const rowId in shadesIdPerGroup) {
            const shadeId = shadesIdPerGroup[rowId];
            let topLeftPath = undefined;
            const groupDetails = moduleDetails.config.groups.find(o => o.rowId === rowId);
            for (const index in groupDetails.modules) {
                const pathSvg = d3
                    .select(cloneSvg)
                    .select("g#FILL")
                    .select("path#" + groupDetails.modules[index])
                    .node();
                const { x, y } = pathSvg.getBoundingClientRect();
                if (!topLeftPath || (topLeftPath.y < y || (topLeftPath.y === y && topLeftPath.x < x))) {
                    topLeftPath = { x, y, shadeId };
                }
            }
            shades.push(topLeftPath);
        }
        return shades.sort((a, b) => (a.y - b.y) * 100000 + a.x - b.x).map(shade => shade.shadeId);
    } finally {
        cloneSvg.remove();
    }
}

/**
 * Génère la page de module dans le PDF final pour une zone PDF donnée
 * @param area
 * @param modulesDetails
 * @param shades
 * @returns {string}
 */
export function moduleListTemplateForAnArea(area, modulesDetails, shades) {
    let template = "";
    area.module.sort((a, b) => (a.box.bottom - b.box.bottom) * 100000 + a.box.left - b.box.left);
    for (const moduleElement of area.module) {
        const moduleDetails = modulesDetails.find(m => m.id === moduleElement.element.modelId());
        const moduleName = (moduleDetails && moduleDetails.terms && this.$tradFor(moduleDetails.terms.name)) || "No Name";
        template += `<div style="display: inline-block;border:1px #ddd solid;width:20% !important;margin: 10px; vertical-align: top">
        Module ${moduleName} (${moduleDetails.id})`;
        const listShades = sortShades(moduleElement.element, moduleDetails);
        template += listShades.length === 0 ? `<p> ${this.$trad.plano.editor.exportPdfModal.noShades} </p>` : "";
        for (const shadeInList of listShades) {
            const shade = shades.find(shade => shade.id === shadeInList);
            if (shade) {
                let shadesProperty = (shade.properties && shade.properties.number && shade.properties.number.numb1.value) || "000";
                template += `<p style="line-height: 1.0;font-size: 13px">${shadesProperty} ${shade.name} </p>`;
            }
        }
        template += "</div>";
    }
    return template;
}

export function formatSvgForPrint(svgChild) {
    let { width, height } = Context.table.paper;
    return `<svg  viewBox=\"${-width / 2} ${-height /
        2} ${width} ${height}\" width="95%" height="95%"  style=\"border:1px #ddd solid;margin: auto; display: block;\" >${svgChild.innerHTML}</svg>`;
}



// WEBPACK FOOTER //
// ./src/plano/utils/pdf.js